module.exports = __webpack_public_path__ + "static/img-slide-3-es-5968b0ddc74b3709ba157847eaa5351d.png";